import { http } from './config'
import moment from 'moment'

export default {

  getLoadHistory: (id) => {
    return http.get(`/loads/${id}/history`)
  },

  getAllLoads: () => {
    return http.get('loads')
  },

  getLoad: (loadId) => {
    return http.get('loads/' + loadId)
  },

  getLoadById: (loadId) => {
    return http.get('loads/' + loadId)
  },

  getOrdersByLoad: (loadId) => {
    return http.get('loads/' + loadId + '/orders')
  },

  getFilteredLoads: (params) => {
    return http.get('loads', { params })
  },

  getFilteredLoadsFinished: (params) => {
    return http.get('loads/loads_finished', { params })
  },

  getBayProducts: (loadId) => {
    return http.get('loads/' + loadId + '/bay_products')
  },
  getLastDeliveryDate: (localityId) => {
    return http.get('loads/last_delivery_date/?locality_id=' + localityId)
  },

  moveBayProducts: (loadId, atualBay, newBay, atualLayer, newLayer, sortedProduct, newQuantity) => {
    return http.post('loads/' + loadId + '/move_bay_products', {
      atual_bay: atualBay,
      new_bay: newBay,
      atual_layer: atualLayer,
      new_layer: newLayer,
      sorted_product: sortedProduct,
      new_quantity: newQuantity,
    })
  },

  createLoad: (loadParams) => {
    return http.post('loads', {
      code: loadParams.code,
      locality_id: loadParams.localityId,
      vehicle_id: loadParams.vehicle.id,
      delivery_date: loadParams.deliveryDate,
      load_step_id: 1,
      integration_id: loadParams.tripNumber,
      load_type_id: loadParams.loadType.id,
    })
  },

  updateLoad: (loadParams) => {
    return http.put('loads/' + loadParams.loadId, {
      code: loadParams.code,
      locality_id: loadParams.locality.id,
      vehicle_id: loadParams.vehicle.id,
      delivery_date: loadParams.deliveryDate,
      daily_operation_id: loadParams.operation_name.id,
      integration_id: loadParams.tripNumber,
      load_type_id: loadParams.loadType.id,
    })
  },

  deleteLoad: (loadId) => {
    return http.delete('loads/' + loadId)
  },

  updateLecturer: (lecturerParams) => {
    let usuario
    if (lecturerParams.user.user_name === '') {
      usuario = ''
    } else {
      usuario = lecturerParams.user.user_name.id
    }
    return http.put('loads/' + lecturerParams.lecturerId, {
      user_id: usuario,
      dock: lecturerParams.dock,
      user_old: lecturerParams.user_old,
      load_sequence: parseInt(lecturerParams.load_sequence),
      vehicle_id: lecturerParams.vehicle.id,
    })
  },

  updateForAllConferents: (lecturerParams) => {
    let dateFormated = moment(lecturerParams.user.delivery_date, 'DD/MM/YYYY').format('YYYY-MM-DD')

    let usuario
    if (lecturerParams.user.user_name === '') {
      usuario = ''
    } else {
      usuario = lecturerParams.user.user_name.id
    }

    return http.put('loads/' + lecturerParams.lecturerId + '/update_all_conferents', {
      user_id: usuario,
      dock: lecturerParams.dock,
      delivery_date: dateFormated,
      user_old: lecturerParams.user_old,
      locality_id: lecturerParams.locality_id,
    })
  },

  getSapLoadProducts: (loadId) => {
    return http.get('loads/' + loadId + '/get_load_products')
  },

  exportLoadsReport: (params) => {
    return http.get('loads/export_loads_report', { params })
  },

  getSortedProductsByLoadId: (loadId) => {
    return http.get('loads/' + loadId + '/sorted_products')
  },

  getPalletizedProductsByLoadId: (loadId) => {
    return http.get('loads/' + loadId + '/palletized_products')
  },

  exportSortedProducts: (loadId, localityId) => {
    return http.get('loads/' + loadId + '/export_sorted_products/?locality_id=' + localityId)
  },

  getLoadsByDataIntegration: (dataIntegrationId) => {
    return http.get('loads/by_data_integration/' + dataIntegrationId)
  },
}
